import LoaderCircle from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/node_modules/.pnpm/lucide-react@1.61.0_@types+react@18.3.31_react@18.3.1/node_modules/lucide-react/dist/esm/icons/loader-circle.mjs";

import { cx } from "../cx";

export interface SpinnerProps {
  /** Accessible label; omit when the parent already announces the busy state. */
  label?: string;
  size?: number;
  className?: string;
}

/** Rotating indicator (FE-02). Rotation stops under prefers-reduced-motion (base.css). */
export function Spinner({ label, size = 20, className }: SpinnerProps) {
  return (
    <span
      role={label ? "status" : undefined}
      aria-label={label}
      className={cx("inline-flex", className)}
    >
      <LoaderCircle aria-hidden="true" size={size} className="animate-spin" />
    </span>
  );
}
